import reducer from './homePageReducer';

export default reducer;
